export default __webpack_public_path__ + "a203641d00ac4702e588357c1ae7e484.png";